// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"styles_socialButton__cISWO","apple":"styles_apple__7n2M8","facebook":"styles_facebook__x9dzA","selected":"styles_selected__srfR9"};